import Layout from '@/layout/index'
import System from './system.js'
import Party from './party.js'
import eLife from './eLife.js'
import ePower from './ePower.js'
import Talent from './talent.js'
import Hetong from './hetong.js'
import crmlist from './crmlist.js'
import afterorder from './afterorder.js'

export default {
  path: '/index',
  component: Layout,
  redirect: '/index/dashboard',
  // name: 'home',
  meta: { title: '工作台' },
  children: [
    {
      path: '/index/dashboard',
      component: () => import('@/views/Dashboard'),
      name: 'Dashboard',
      meta: { title: '工作台' }
    },
    {
      path: '/index/statistics',
      component: () => import('@/views/Statistics'),
      name: 'Statistics',
      meta: { title: '数据统计' }
    },
    {
      path: '/index/Workcg',
      name: 'Workcg',
      component: () => import('@/views/Workcg'),
      meta: { title: '工作台' }
    },
    System,
    Party,
    eLife,
    ePower,
    Talent,
    Hetong,
    crmlist,
    afterorder
  ]
}
